import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { TimetableAmend } from './TimetableAmend';
import { TimetableCreate } from './TimetableCreate';
import { TimetableDisplay } from './TimetableDisplay';
import { TimetableSearch } from './TimetableSearch';
import { TimetableUpdate } from './TimetableUpdate';

export const TimetableRoutes = (): React.JSX.Element => {
  return (
    <Routes>
      <Route path="/amend/:key" element={<TimetableAmend />} />
      <Route path="/search" element={<TimetableSearch />} />
      <Route path="/create" element={<TimetableCreate />} />
      <Route path="/display/:key" element={<TimetableDisplay />} />
      <Route path="/update/:key" element={<TimetableUpdate />} />
      <Route path="*" element={<Four04 />} />
    </Routes>
  );
};
